export const allowedStates = ['gray', 'notice', 'warning', 'error', 'success', 'brand', 'disabled'] as const;
export type AllowedState = (typeof allowedStates)[number];
